import Vue from 'vue'
import ElementUI from 'element-ui';
import '@/style/index.scss';
import router from "@/router"
import store from '@/store'
import '@/permission' // progress bar
import vMessage from '@/components/Message/index.js'
import {directiveInstall} from"@/directives/index.js"
import '@/directives/dragDialog.js';
//import "./icons"
import Bus from '@/utils/bus'
import ThemeInfo from '@/style/theme/themeInfo'

import "@/style/iconfont/iconfont.css"

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import requestMethods from "@/utils/request"
for(let key in requestMethods){
  Vue.prototype[key] = requestMethods[key]
}
Vue.prototype.$Bus = Bus
Vue.prototype.$ThemeInfo = ThemeInfo
Vue.config.productionTip = false

import i18n from '@/utils/i18n'
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, {
  locale,
  size: 'medium', // set element-ui default size
    zIndex:3000
}) 
Vue.use(vMessage)
Vue.use(directiveInstall)

export const mainObj = {
    i18n : i18n,
    router : router,
    store :store
}  
